const modes = {
    dark: 'class',
    light: 'class'
};

export { modes as default };
